import { render, staticRenderFns } from "./ImageUploader3.vue?vue&type=template&id=3346147c&scoped=true&"
import script from "./ImageUploader3.vue?vue&type=script&lang=ts&"
export * from "./ImageUploader3.vue?vue&type=script&lang=ts&"
import style0 from "./ImageUploader3.vue?vue&type=style&index=0&id=3346147c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3346147c",
  null
  
)

export default component.exports